import { useState } from 'react';
import api from '../../services/api';
import { useToast } from '../../contexts/ToastContext';
import PromoterProfileForm from '../../components/PromoterProfileForm';

export default function PromoterProfileSection({ profile, onProfileChange }) {
  const { addToast } = useToast();
  const [editingProfile, setEditingProfile] = useState(false);

  // PromoterProfileForm appelle onSuccess() sans argument → on refetch
  // (même pattern que ArtistDashboard / BookerDashboard)
  async function handleProfileCreated() {
    try {
      const res = await api.get('/promoters/profile/me');
      onProfileChange(res.data.profile || res.data);
      setEditingProfile(false);
      addToast('Profil créé avec succès');
    } catch (err) {
      addToast(err.message, 'error');
    }
  }

  async function handleProfileUpdated() {
    try {
      const res = await api.get('/promoters/profile/me');
      onProfileChange(res.data.profile || res.data);
      setEditingProfile(false);
      addToast('Profil mis à jour');
    } catch (err) {
      addToast(err.message, 'error');
    }
  }

  return (
    <section className="mb-10">
      <h2 className="th-section-title mb-4">Mon Profil</h2>
      {!profile ? (
        <PromoterProfileForm mode="create" onSuccess={handleProfileCreated} />
      ) : editingProfile ? (
        <PromoterProfileForm mode="edit" initialData={profile} onSuccess={handleProfileUpdated} />
      ) : (
        <div className="border th-border p-6 th-bg-surface">
          <div className="flex items-start justify-between">
            <div>
              <p className="font-mono font-medium th-text text-sm">{profile.companyName || 'Profil Promoteur'}</p>
              <p className="text-xs th-text-muted font-mono mt-2">
                {profile.city && profile.country ? `${profile.city}, ${profile.country}` : 'Localisation non définie'}
              </p>
              {profile.bio && <p className="text-xs th-text-secondary mt-3">{profile.bio}</p>}
            </div>
            <button
              onClick={() => setEditingProfile(true)}
              className="th-btn"
            >
              Modifier
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
